import { Language2 } from "@common/logic/services/language-service";
import { createContext, useContext } from "react";

export const LocaleContext = createContext<Language2 | null>(null);

export function useLocale() {
  const locale = useContext(LocaleContext);
  if (!locale) {
    throw new Error("LocaleContext not found");
  }

  return locale;
}
